import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { PageHeader, Tag } from 'antd';
import { pageHeaderStyle, pageTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';
import PriceListStore from '../stores/PriceListStore';
import PriceControl from './PriceControl';
import PriceSummary from './PriceSummary';
import PriceDrawer from './PriceDrawer';

const height = window.innerHeight * .60;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};


const columnDefs = [
    { headerName: 'Branch Code', field: 'BranchCode', pinned: 'left', width: 75 },
    { headerName: 'id', field: 'ReferrerId', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 100, pinned: 'left' },
    { headerName: 'Referrer Name', field: 'ReferrerName', filter: 'agTextColumnFilter', pinned: 'left', width: 250 },
    { headerName: 'Current Price', field: 'Amount', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 125 },
    { headerName: 'Prefered Price', field: 'prefered_price', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 125 },
    { headerName: 'Selective Price', field: 'selective_price', editable: true, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 125 },
    { headerName: 'Membership Discount', field: 'MemberShipDiscount', editable: true, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 125 },
    { headerName: 'Sr.Ctr.Discount', field: 'senior_citizen_discount',
    editable: true, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 125},
    { headerName: 'Type', field: 'ReferrerTypeId', editable: false, type: 'numberColumn', filter: 'agNumberColumnFilter', width: 50 },
   
];

class ProductPriceList extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        const kind = props.params.kind;
        const productId = props.params.productId;
        const departmentId = props.params.departmentId;
        const priceUpdateFlag = props.params.priceUpdateFlag;
        this.store = new PriceListStore({ apiProxy: props.appStore.apiProxy, kind, productId, departmentId, role: props.appStore.credentials.role, priceUpdateFlag });
    }

    fetchPriceList = () => {
        this.store.fetchPriceList();
    }

    refreshPriceGrid = () => {
        this.gridRef.current.api.redrawRows();
    }

    countTag = () => {
        if (this.store.isDone) {
            return (
                <>
                    <Tag color="#108ee9">{this.store.rowCount} Total</Tag>
                    {this.store.isApproved && <Tag color="#87d068">Approved</Tag>}
                </>
            )
        }

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }
    }

    onSelectionChanged = () => {


        const selectedRows = this.gridRef.current.api.getSelectedRows();
        
        const referrerId = selectedRows[0].ReferrerId;

        this.store.referrerId = referrerId;

        this.store.fetchPriceHistory(referrerId);
        
        this.store.isDrawerOpened = true;

        //this.gridRef.current.api.deselectAll();
    }

    render() {
        const priceList = this.store.priceList;
        const productName = this.props.params.productName;
        return (
            <div>
                <PageHeader
                    style={pageHeaderStyle}
                    title={pageTitle(productName)}
                    tags={this.countTag()}
                >
                    <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: "5px" }}>
                        <div className="ag-theme-alpine" style={{ height: height, width: '75%' }}>
                            <AgGridReact
                                ref={this.gridRef}
                                defaultColDef={defaultColDef}
                                rowData={priceList}
                                columnDefs={columnDefs}
                                enterMovesDown={true}
                                rowSelection={'single'}
                                onSelectionChanged={this.onSelectionChanged}
                                enterMovesDownAfterEdit={true}
                                onGridReady={this.fetchPriceList}
                                rowHeight={25}
                            >
                            </AgGridReact>
                        </div>
                        <div>
                            <PriceDrawer store={this.store}></PriceDrawer>
                        </div>
                        <div style={{ width: '25%', height: height }}>
                            <PriceControl store={this.store} appStore={this.props.appStore} labPrice={this.props.params.labPrice} selfPrice={this.props.params.selfPrice} refreshPriceGrid={this.refreshPriceGrid} />
                        </div>
                    </div>
                    <PriceSummary store={this.store} appStore={this.props.appStore} refreshPriceGrid={this.refreshPriceGrid} />
                </PageHeader>

            </div>
        )
    }
}

export default observer(ProductPriceList)
